import { render, staticRenderFns } from "./SupplierOnboardingLegalRepresentativeData.vue?vue&type=template&id=18bd17a4&"
import script from "./SupplierOnboardingLegalRepresentativeData.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingLegalRepresentativeData.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingLegalRepresentativeData.vue?vue&type=style&index=0&id=18bd17a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports